import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M58.8501 1.66992H2.26009C2.26009 1.66992 -0.879918 25.2799 6.06008 39.3199C6.06008 39.3199 9.69009 35.1899 30.0001 35.1899C50.3101 35.1899 55.0501 39.3199 55.0501 39.3199C61.9901 25.2899 58.8501 1.66992 58.8501 1.66992Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
